module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-scrollDiv', {
    staticClass: "type-main",
    style: ({
      height: _vm.list_height + 'px'
    })
  }, [_c('div', {
    staticClass: "type-slot"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-08745756!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/type-choose.vue
// module id = 686
// module chunks = 1